import { render, staticRenderFns } from "./tcgaExpressionAll.vue?vue&type=template&id=452150d0&scoped=true&"
import script from "./tcgaExpressionAll.vue?vue&type=script&lang=js&"
export * from "./tcgaExpressionAll.vue?vue&type=script&lang=js&"
import style0 from "./tcgaExpressionAll.vue?vue&type=style&index=0&id=452150d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452150d0",
  null
  
)

export default component.exports